import React, {Component} from 'react'
import {request} from "../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import UserGeneralInfo from "./component/UserGeneralInfo";
import UserBranchInfo from "./component/UserBranchInfo";
import Alert from "react-s-alert";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Table from "../../components/Table/Table";
import UserAliasInfo from "./component/UserAliasInfo";
import ChangePassword from "./component/ChangePassword";
import SweetAlert from 'react-bootstrap-sweetalert';

class UserProfile extends Component {

	constructor(props) {
		super(props);

		this.state = {
			activeBranchModal: false,
			userAliasList: [],
			selectedAliasList: [],
			newStateOfAliasList:null,
			passwordModal: false,
			passwordPayload: {
				currentPassword: null,
				newPassword: null,
				newPasswordCopy: null
			},
			alert: null,
			enablePasswordEvent:true,

		};

		this.onChangeGeneralInfo = this.onChangeGeneralInfo.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.openActiveBranchModal = this.openActiveBranchModal.bind(this);
		this.closeActiveBranchModal = this.closeActiveBranchModal.bind(this);
		this.handleChangeUserBranches = this.handleChangeUserBranches.bind(this);
		this.onChangeAlias = this.onChangeAlias.bind(this);
		this.handleChangeUserAliasList = this.handleChangeUserAliasList.bind(this);
		this.closePasswordModal = this.closePasswordModal.bind(this);
		this.onChangePasswordPayload = this.onChangePasswordPayload.bind(this);
		this.openPreWarningForPasswordChange = this.openPreWarningForPasswordChange.bind(this);
		this.setPasswordPayload = this.setPasswordPayload.bind(this);
		this.onBlurPasswordPayload = this.onBlurPasswordPayload.bind(this);
		this.passwordValidation = this.passwordValidation.bind(this);
		this.verification = this.verification.bind(this);
	}

	componentDidMount() {
		this.fetchCompleteUser();
		this.fetchRelatedCustomer();
		this.fetchCustomerAliasList()
	}

	fetchCompleteUser() {
		let self = this;
		let params = {
			url: `/user/fetchCompleteUser/${this.props.currentUser.id}`,
			method: 'post'
		};
		let initStateData = null;
		request(params)
			.then(function (response) {
				initStateData = response.data;
				self.setState({completeUser: response.data})
			})
			.then(() => self.fetchReadableUserBranches())
			.then(() => self.arrangeSelectedAliasList())
			.then(() => self.prepareInitStates(initStateData))
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	prepareInitStates(data) {
		let generalInfoInitState = {};
		generalInfoInitState.firstName = data.firstName;
		generalInfoInitState.lastName = data.lastName;
		generalInfoInitState.username = data.username;
		generalInfoInitState.email = data.email;
		generalInfoInitState.addDraftWatermark = data.addDraftWatermark;
		this.setState({generalInfoInitState})
	}

	fetchRelatedCustomer() {
		let self = this;
		let params = {
			url: `/user/fetchRelatedCustomer`,
			method: 'post'
		};
		request(params)
			.then(function (response) {
				self.setState({currentCustomer: response.data})
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	fetchReadableUserBranches() {
		let self = this;
		let data = self.state.completeUser.branchList;
		let params = {
			url: `/user/fetchReadableUserBranches`,
			method: 'post',
			data: data
		};
		request(params)
			.then(function (response) {
				self.prepareBranchesToShow(response.data);
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	prepareBranchesToShow(data) {
		let activeBranchToShow = null;
		let activeBranchOtherInfo = {};

		data.map(b => {
			if (b.active) {
				activeBranchToShow = (b.branchName ? b.branchName : '') + ': ' + (b.street ? b.street : '') + ' '
					+ (b.buildingName ? b.buildingName : '') + ' ' + (b.buildingNo ? b.buildingNo : '') + ' '
					+ (b.doorNo ? b.doorNo : '') + ' ' + (b.postalCode ? b.postalCode : '') + ' '
					+ (b.citySubdivisionName ? b.citySubdivisionName : '') + '-' + (b.city ? b.city : '') + ' / '
					+ (b.country ? b.country : '');
			}

			activeBranchOtherInfo.activeBranchEmail = b.email;
			activeBranchOtherInfo.activeBranchPhone = b.phone;
			activeBranchOtherInfo.activeBranchFax = b.fax;
			activeBranchOtherInfo.activeBranchGbAlias = b.gbAlias;
			activeBranchOtherInfo.activeBranchPkAlias = b.pkAlias;

		});

		let steadyStateOfBranches = JSON.stringify(data);

		this.setState({
			steadyStateOfBranches,
			userBranches: data,
			activeBranchToShow,
			activeBranchOtherInfo
		})
	}

	onConfirmAlert() {
		this.setState({
			alert: null,
			enablePasswordEvent:true
		})
	}

	onChangeGeneralInfo(e) {
		let completeUser = deepCopyObject(this.state.completeUser);

		if (e.target.name === 'username') {
			let username = e.target.value;
			let regex = new RegExp(/[A-ZşŞıİçÇöÖüÜĞğ!@#$%^&*(),.?"':;{}|<>\\/]/g);

			if (username.match(regex) !== null) {
				this.setState({
					alert: (
						<SweetAlert warning
									title="Uyarı"
									confirmBtnText="Tamam"
									confirmBtnBsStyle="danger"
									onConfirm={() => this.onConfirmAlert()}>
							<p>Kullanıcı Adı:</p>
							<ul>
								<li>Harf ve/veya rakamlardan oluşmalıdır.</li>
								<li>Yalnızca küçük harf bulundurabilir.</li>
								<li>Türkçe karakter içeremez.</li>
								<li>- veya _ dışında özel karakter içeremez.</li>
							</ul>
						</SweetAlert>
					)
				})
			} else {
				completeUser[e.target.name] = e.target.value;
			}
		} else if (e.target.name === "addDraftWatermark") {
			completeUser[e.target.name] = e.target.value !== "0";
		} else {
			completeUser[e.target.name] = e.target.value;
		}

		this.setState({
			completeUser
		});
	}

	handleSubmit() {
		let self = this;
		let data = deepCopyObject(self.state.completeUser);
		let params = {
			url: `/user/updateProfile`,
			data: data,
			method: 'post'
		};
		request(params).then(() => {
			Alert.success('Kaydedildi.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});
		}).then(() => self.props.loadCurrentUser())
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	openActiveBranchModal() {
		this.setState({activeBranchModal: true})
	}

	closeActiveBranchModal() {
		this.setState({activeBranchModal: false})
	}

	selectAsActiveBranch(data) {
		let newActiveBranchId = data.recordId;
		let userBranchesToShow = deepCopyObject(this.state.userBranches);
		let user = deepCopyObject(this.state.completeUser);
		let userBranches = user.branchList;

		userBranchesToShow.map(ubts => {
			if (ubts.active && ubts.recordId !== newActiveBranchId) {
				ubts.active = false;
			}
			if (ubts.recordId === newActiveBranchId) {
				ubts.active = true;
			}
		});

		userBranches.map(ub => {
			if (ub.active && ub.recordId !== newActiveBranchId) {
				ub.active = false;
			}
			if (ub.recordId === newActiveBranchId) {
				ub.active = true;
			}
		});

		let newStateOfBranches = JSON.stringify(userBranchesToShow);

		this.setState({
			completeUser: user,
			newStateOfBranches,
			userBranches: userBranchesToShow
		})
	}

	handleChangeUserBranches() {
		this.handleSubmit();
		this.prepareBranchesToShow(this.state.userBranches);
		this.setState({
			activeBranchModal: false
		})
	}

	fetchCustomerAliasList() {
		let self = this;
		let params = {
			url: `/user/getAliasList`,
			method: 'post'
		};
		request(params).then(function (response) {
			self.setState({customerAliasList: response.data});
		})
			.then(() => {
				self.arrangeUserAliasList(self.state.customerAliasList)
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	arrangeSelectedAliasList() {
		let completeUser = deepCopyObject(this.state.completeUser);
		let selectedAliasList = [];

		completeUser.userAliasList.map(ua => {
			selectedAliasList.push(ua.alias.recordId);
		});

		let steadyStateOfAliasList = JSON.stringify(selectedAliasList);

		this.setState({
			selectedAliasList,
			steadyStateOfAliasList
		})
	}

	arrangeUserAliasList(data) {
		let userAliasList = deepCopyObject(this.state.userAliasList);

		if (data) {
			data.map(a => {
				let found = false;
				!!userAliasList && userAliasList.map(alias => {
					if (alias.value === a.recordId) {
						found = true;
					}
				});
				if (!found) {
					let alias = {};
					const cancelFlag = (a.actionType === 'C' && a.processState === 500 && a.processResult === 1300 && !a.gibRegistrationState)
					alias.value = a.recordId;
					alias.style = {color: (cancelFlag ? '#FF0000' : '#007eff')}
					if (!!a.workScopecode) {
						alias.label = a.service.ublCode + ': ' + a.workScopecode + (cancelFlag ? "(İPTAL)" : "");
					} else if (!a.workScopecode) {
						alias.label = a.service.ublCode + (cancelFlag ? "(İPTAL)" : "")
					}
					userAliasList.push(alias)
				}
			})
		}

		this.setState({userAliasList})
	}

	onChangeAlias(data) {
		let newStateOfAliasList = JSON.stringify(data)

		this.setState({
			selectedAliasList: data,
			newStateOfAliasList
		})
	}

	handleChangeUserAliasList() {
		let selectedAliasList = deepCopyObject(this.state.selectedAliasList);
		let user = deepCopyObject(this.state.completeUser);
		let userAliasList = deepCopyObject(user.userAliasList);
		let newUserAliasList = [];
		let newUserAlias = {alias: {}}

		let found = false;
		selectedAliasList.forEach(selectedAlias => {
			userAliasList.forEach(userAlias=>{
				 if(selectedAlias.value === userAlias.alias.recordId){
					 newUserAliasList.push(userAlias);
					 found = true;
				 }
			})
			if(found===false){
				newUserAlias.alias.recordId = selectedAlias.value;
				newUserAliasList.push(newUserAlias)
				newUserAlias = {alias: {}};
			}
			found = false
		})

		user.userAliasList = newUserAliasList;

		this.setState({completeUser: user},
			() => this.handleSubmit(), () => this.props.history('/userProfile'))
	}

	onConfirmPreWarning() {
		this.setState({
			alert: null,
			passwordModal: true
		})
	}

	openPreWarningForPasswordChange() {
		this.setState({
			alert: (
				<SweetAlert warning
							title="Dikkat"
							confirmBtnText="Devam Et"
							confirmBtnBsStyle="warning"
							onConfirm={() => this.onConfirmPreWarning()}>
					Yeni şifrenizi oluştururken lütfen Türkçe karakter kullanmayınız.
				</SweetAlert>
			)
		})
	}

	closePasswordModal() {
		this.setState({
			passwordModal: false,
			passwordPayload: {
				currentPassword: null,
				newPassword: null,
				newPasswordCopy: null
			}
		})
	}

	verification(password,rule,eventType){
		if(!(this.state.enablePasswordEvent))
			return false;
		if(eventType === rule.eventType || eventType === "both"){
			if(rule.type==="test"){
				if(password.length===0){
					if(rule.eventType === "blur")
						return true;
					return false;
				}

				return (!(rule.exp.test(password)));
			}
			else if(rule.type ==="search"){
				return password.search(rule.exp) === -1;
			}
			return  false;
		}
		else
			return false;
	}

	passwordValidation(password,eventType, name){
		if(name && name==='currentPassword'){
			return {
				error:false,
				errorMessage:""
			};
		}

		const rules =[
			{
				exp:/^\S*$/,
				message: "Parolada boşluk olamaz!",
				type:"test",
				eventType:"change"
			},
			{
				exp: /[!@#$%^&*(),.?":{}|<>]/,
				message: "Parola en az bir özel karakter içermelidir!",
				type: "search",
				eventType: "blur"
			},

			{
				exp:/^.{8,}$/,
				message: "Parola en az 8 karakter içermelidir!",
				type:"test",
				eventType: "blur"
			},
			{
				exp:/[0-9]/,
				message: "Parola en az bir  sayı içermelidir!",
				type:"search",
				eventType: "blur"
			},
			{
				exp:/[A-Z]/,
				message: "Parola en az bir büyük harf içermelidir!",
				type:"search",
				eventType: "blur"
			},
			{
				exp:/[a-z]/,
				message: "Parola en az bir küçük harf içermelidir!",
				type:"search",
				eventType: "blur"
			}
		]
		let passwordState = {
			error:false,
			errorMessage:""
		};
		for (const index in rules) {

			if(this.verification(password,rules[index],eventType)){
				passwordState.error=true;
				passwordState.errorMessage = rules[index].message;
				this.setState({enablePasswordEvent:false});
				if(eventType === "both")
					this.setState({enablePasswordEvent:true});
				return passwordState;
			}
		}
		return passwordState;
	}

	onChangePasswordPayload(e) {
		let {name,value} = e.target;
		let validate = this.passwordValidation(value,e.type,name);
		this.setPasswordPayload(validate,e);
	}

	onBlurPasswordPayload(e){
		let {name,value} = e.target;
		let validate = this.passwordValidation(value,e.type,name);
		this.setPasswordPayload(validate,e);
	}

	setPasswordPayload(validate,e){
		let passwordPayload = deepCopyObject(this.state.passwordPayload);
		if (validate.error) {
			this.setState({
				alert: (
					<SweetAlert warning
								title="Uyarı"
								confirmBtnText="Tamam"
								confirmBtnBsStyle="danger"
								onConfirm={() => this.onConfirmAlert()}>
						{validate.errorMessage}
					</SweetAlert>
				)
			})
		}else {
			passwordPayload[e.target.name] = e.target.value;
			this.setState({
				passwordPayload
			})
		}
	}

	render() {

		let userBranches = [];
		if (this.state.userBranches) {
			userBranches = deepCopyObject(this.state.userBranches);
		}

		const columns = [
			{
				Header: "Aktif",
				title : 'Aktif',
				accessor: "recordId",
				sortable: false,
				Cell: (row) => (<input type="radio" checked={row.active} onChange={() => this.selectAsActiveBranch(row)}/>)
			},
			{
				Header: "Adres Adı",
				accessor: "branchName"
			},
			{
				Header: "İlçe",
				accessor: "citySubdivisionName"
			},
			{
				Header: "Şehir",
				accessor: "city",
			},
			{
				Header: "Telefon",
				accessor: "phone"
			},
			{
				Header: "E-posta",
				accessor: "email"
			},
			{
				Header: "Web Sitesi",
				accessor: "webSite"
			}
		];
		return (
			<div>

				{this.state.alert && this.state.alert}

				<div className='card-header'>
					<h4 className="card-title">Kullanıcı Profili</h4>
				</div>

				<div className="card-body">
					<div className="FormRenk col-sm-12" style={{paddingLeft: '0', paddingTop: '0'}}>

						<UserGeneralInfo completeUser={this.state.completeUser} currentCustomer={this.state.currentCustomer}
										 impersonateUserRoleId={this.props.impersonateUserRoleId}
										 onChangeGeneralInfo={this.onChangeGeneralInfo} handleSubmit={this.handleSubmit}
										 openPreWarningForPasswordChange={this.openPreWarningForPasswordChange} initState={this.state.generalInfoInitState}
										 />

					</div>
				</div>
				<div className="card-body">
					<div className="FormRenk col-sm-12" style={{paddingLeft: '0', paddingTop: '0'}}>

						<UserBranchInfo activeBranchToShow={this.state.activeBranchToShow}
										activeBranchOtherInfo={this.state.activeBranchOtherInfo}
										userBranches={this.state.userBranches}
										openActiveBranchModal={this.openActiveBranchModal}/>

					</div>
				</div>
				<div className="card-body">
					<div className="FormRenk col-sm-12" style={{paddingLeft: '0', paddingTop: '0'}}>

						<UserAliasInfo customerAliasList={this.state.customerAliasList}
									   selectedAliasList={this.state.selectedAliasList}
									   userAliasList={this.state.userAliasList}
									   onChangeAlias={this.onChangeAlias}
									   handleChangeUserAliasList={this.handleChangeUserAliasList}/>

					</div>
				</div>
				<ChangePassword isOpen={this.state.passwordModal}
								currentUser={this.props.currentUser}
								logOut={this.props.logOut}
								closePasswordModal={this.closePasswordModal}
								passwordPayload={this.state.passwordPayload}
								onChangePasswordPayload={this.onChangePasswordPayload}
								onBlurPasswordPayload={this.onBlurPasswordPayload}
								passwordValidation={this.passwordValidation}
								impersonate={this.props.impersonate}/>

				<Modal isOpen={this.state.activeBranchModal} size="lg">
					<ModalHeader toggle={() => this.closeActiveBranchModal()}>Şube Düzenle</ModalHeader>
					<ModalBody>
						<div className='col-sm-12'>
							<Table columns={columns}
								   loading={this.state.loading}
								   loadingText="Kayıtlar getiriliyor..."
								   content={userBranches}
								   total={userBranches.length}
								   page={this.state.page}
								   manual={this.state.manual}
								   size={this.state.size}
								   options={["5", "10", "20", "50"]}
								   fetchData={this.fetchBranchList}
								   paginationEnabled={false}
							/>
						</div>
					</ModalBody>
					<ModalFooter>
						<button disabled={!this.state.newStateOfBranches || this.state.steadyStateOfBranches === this.state.newStateOfBranches}
								onClick={this.handleChangeUserBranches}>Onayla
						</button>
					</ModalFooter>
				</Modal>
			</div>
		)
	}
}

export default UserProfile;